import React from 'react';

export default function ManagedInOdooNotice({ what = 'Schedules and requests' }) {
  return (
    <div className="alert alert-info mb-2">
      {what} are managed in Odoo now. Use Odoo → Driver Schedule to create, edit, approve or deny.
    </div>
  );
}
